import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dayofweek' })
export class DayOfWeekPipe implements PipeTransform {
    transform(d) {

        let day = 'Unknown Day';

        switch (d) {
            case 0:
                day = 'Sunday';
                break;
            case 1:
                day = 'Monday';
                break;
            case 2:
                day = 'Tuesday';
                break;
            case 3:
                day = 'Wednesday';
                break;
            case 4:
                day = 'Thursday';
                break;
            case 5:
                day = 'Friday';
                break;
            case 6:
                day = 'Saturday';
                break;
            default:
                day = 'Unknown Day';
        }
        return day;
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/day-of-week.pipe.ts